import { appStatus } from '../use/useAppStatus'; 
import { IStructureNotification } from '../interfaces/structure-notification.interface';


 // Check the action to determine how to handle the push notification
function onHandleMessageEvent(e: any) {
  const messageData = e.data; 
  console.log(messageData)
  let newNotifData = null;

  console.log("receive message from service worker");
 
  if (messageData.action === "goodEveningReminder") {
      newNotifData = [{
          id: "goodEveningReminder",
          type: "pushNotification", // callToAction, information, achievement, pushNotification
          icon: "action", // action,survey,celebration
          asset: "",
          textCollapsed: "Complete your entries",
          textCollapsedSummary: "",
          textExpanded: "Good evening. Remember to go and complete your TouchPoints Diary for the day. Touchpointsdiary.ipsos.com",
          time: Date.now(),
          display: true,
          viewed:false,
      }];
  }

  if (messageData.action === "goodMorningWeekdaysReminder") {
      newNotifData = [{
          id: "goodMorningWeekdaysReminder",
          type: "pushNotification", // callToAction, information, achievement, pushNotification
          icon: "action", // action,survey,celebration
          asset: "",
          textCollapsed: "Complete your entries",
          textCollapsedSummary: "",
          textExpanded: "Good Morning. Remember to go to your TouchPoints Diary and fill it in today. Touchpointsdiary.ipsos.com",
          time: Date.now(),
          display: true,
          viewed:false,
      }];
  }

  if (messageData.action === "goodMorningWeekendsReminder") {
      newNotifData = [{
          id: "goodMorningWeekendsReminder",
          type: "pushNotification", // callToAction, information, achievement, pushNotification
          icon: "action", // action,survey,celebration
          asset: "",
          textCollapsed: "Complete your entries",
          textCollapsedSummary: "",
          textExpanded: "Good Morning. Remember to go to your TouchPoints Diary and fill it in today. Touchpointsdiary.ipsos.com",
          time: Date.now(),
          display: true,
          viewed:false,
      }];
  }

  // Save notification data to appStatus to trigger update
  appStatus.notificationList.push(JSON.stringify(newNotifData));

  // Save notification data to localStorage to avoid user refresh and lost all previous notification
  const existingData = localStorage.getItem("notificationData");
  if (existingData === null) {
    if (newNotifData) {
      localStorage.setItem("notificationData", JSON.stringify(newNotifData));
    }
  } else {
    // Get the existing JSON array from localStorage
    const existingDataString = localStorage.getItem("notificationData");
    const existingData: IStructureNotification[] = JSON.parse(existingDataString || "[]");

    if(newNotifData != null)
    {
        const newData: IStructureNotification = {
          back_end_id: 0, //push notification no sync on database
          id: newNotifData[0].id,
          type: newNotifData[0].type,
          icon: newNotifData[0].icon,
          asset: newNotifData[0].asset,
          textCollapsed: newNotifData[0].textCollapsed,
          textCollapsedSummary: newNotifData[0].textCollapsedSummary,
          textExpanded: newNotifData[0].textExpanded,
          time: Date.now(),
          display: true,
          viewed:false
        };
        // Add the new data to the existing array
        existingData.push(newData);
        // Store the updated array back into localStorage
        localStorage.setItem("notificationData", JSON.stringify(existingData));
    }
  }
}


export function usePushNotificationReceiver() {
  return {
    onHandleMessageEvent,
  };
}